import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCompanyImpersonationModal',
  emits: ["company-selected", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'company-selected', companyName: string): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { $fetcher, $user } = useContext()



async function search(searchTerm: string): Promise<
  Array<{
    id: string
    value: string
  }>
> {
  const results = await $fetcher.$get('/api/company/search', {
    query: { search: searchTerm },
  })

  return results.map((result: any) => ({
    id: result.companyExternalId,
    value: result.companyName,
  }))
}

function close() {
  emit('close')
}

function select(companyId: string) {
  emit('close')
  emit('company-selected', companyId)
}

return { __sfc: true,$fetcher, $user, emit, search, close, select }
}

})